import Lottie from "lottie-react";
import LoadingAnimation from "../animations/LoadingAnimation.json";
import { useEffect, useState } from "react";

function SlideLoader({ showProgress, wpProgress, isPageActive = false }) {
    const [progress, setProgress] = useState(0);
    const [newProgress, setNewProgress] = useState(wpProgress?.progress || 0);

    useEffect(() => {
        if (wpProgress?.progress !== undefined && isPageActive) {
            setNewProgress(wpProgress.progress);
        }
    }, [wpProgress?.progress, isPageActive]);

    useEffect(() => {
        if (isPageActive && progress !== newProgress) {
            const isFinalStretch = newProgress === 100;
            const totalDuration = isFinalStretch ? 1000 : Math.abs(newProgress - progress) * 300;
            const stepTime = totalDuration / Math.abs(newProgress - progress);

            const increment = progress < newProgress ? 1 : -1;
            const interval = setInterval(() => {
                setProgress((prev) => {
                    const nextValue = prev + increment;
                    if ((increment > 0 && nextValue >= newProgress) || (increment < 0 && nextValue <= newProgress)) {
                        clearInterval(interval);
                        return newProgress;
                    }
                    return nextValue;
                });
            }, stepTime);

            return () => clearInterval(interval);
        }
    }, [newProgress, isPageActive]);

    // SVG Circle Animation
    const radius = 45;
    const circumference = 2 * Math.PI * radius;
    const strokeDashoffset = circumference - (progress / 100) * circumference;

    return (
        <div id="uo-loader" className="uo-component div-50-50">
            <div id="uo-loader-animation-banner">
                <div id="uo-loader-ab-container">
                    {showProgress ? (
                        <div id="uo-l-progress" className="progress-container flex-c">
                            <svg width="120" height="120" viewBox="0 0 100 100">
                                <circle cx="50" cy="50" r={radius} stroke="#ddd" strokeWidth="5" fill="none" />
                                <circle
                                    cx="50"
                                    cy="50"
                                    r={radius}
                                    stroke="#d76429"
                                    strokeWidth="5"
                                    fill="none"
                                    strokeDasharray={circumference}
                                    strokeDashoffset={strokeDashoffset}
                                    strokeLinecap="round"
                                    transform="rotate(-90 50 50)"
                                    style={{ transition: "stroke-dashoffset 0.5s ease-in-out" }}
                                />
                            </svg>
                            <em className="progress-text">{progress}%</em>
                        </div>
                    ) : (
                        <Lottie className="workout-animation" animationData={LoadingAnimation} loop={true} />
                    )}
                </div>
            </div>

            <div id="uo-pi-pm-text" className="bottom-text-area">
                <h4>Hold tight! We're adding your programs to indi.</h4>
            </div>
        </div>
    );
}

export default SlideLoader;
